import type { CMSChipLinkDTO } from "~/features/cms/types/dto";
import CMSChipLinkPopup from "~/features/cms/components/cmsChip/CMSChipLinkPopup";
import CMSChipLinkStandard from "~/features/cms/components/cmsChip/CMSChipLinkStandard";
import type { ChipVariant } from "~/common/mui/Chip/Chip";

export interface CMSChipLinkProps extends Omit<CMSChipLinkDTO, "type"> {
  className?: string;
  variant?: ChipVariant;
}

export const CMSChipLink = ({ chip, iconUrl, className, variant }: CMSChipLinkProps) => {
  const url = chip.navigationEntry.linkComponent.url;
  const isBulkEntry = url.includes("/bulkEntry");

  if (isBulkEntry) {
    return <CMSChipLinkPopup chip={chip} iconUrl={iconUrl} className={className} variant={variant} />;
  }

  return <CMSChipLinkStandard chip={chip} iconUrl={iconUrl} className={className} variant={variant} />;
};
